import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { User } from 'src/app/core/models';
import { StorageKey, StorageService } from 'src/app/core/services';

@Injectable({
  providedIn: 'root'
})
export class VerifyPermissionUrl {

  constructor(
    private readonly storageService: StorageService,
    private router: Router,
  ) { }

  execute(requiredPermissions: string[]) {
    const user: User = this.storageService.get(StorageKey.currentUser);
    const permissions: string[] = this.storageService.get(StorageKey.adminPermissions) || [];

    if (user?.superUser) {
      return;
    }

    const hasPermission = requiredPermissions.some(permission =>
      permissions.includes(permission)
    );

    if (!hasPermission) {
      this.router.navigate(['/']);
    }
  }
}
